import { createValidate } from 'typia'
import { validateGuard } from 'components/shared/parsing/parsing.js'

export type IStockDTO = {
  stock_amount: number
  amount: number
  delivery_days: number
  description: string
  msg: string
  show: boolean
  type: string
  alt_msg: string
}

export class StockDTO {
  stockAmount: number
  amount: number
  deliveryDays: number
  description: string
  msg: string
  show: boolean
  type: string
  altMsg: string

  constructor(data: IStockDTO) {
    this.stockAmount = data.stock_amount
    this.amount = data.amount
    this.deliveryDays = data.delivery_days
    this.description = data.description
    this.msg = data.msg
    this.show = data.show
    this.type = data.type
    this.altMsg = data.alt_msg
  }
}

const validateStockDTO = createValidate<IStockDTO>()

export const parseStockDTO = (data: unknown) => {
  if (data === null) return null
  validateGuard(validateStockDTO, data, 'StockDTO')
  return new StockDTO(data)
}
